import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  return (
    <div className="privacy">
      <Header />
      <div className="main-content  full-width  inner-page">
        <div className="background-content" />
        <div className="background">
          <div className="shadow" />
          <div className="pattern">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div
                      className="col-md-12 center-column  content-with-background "
                      id="content"
                    >
                      <div style={{ paddingBottom: 10 }}>
                        {/* Data Privacy Policy Page */}
                        <div className="pdh-page pdh-policy-page">
                          <section className="pdh-section pdh-container">
                            {/* Page Title */}
                            <h1 className="pdh-policy-title">
                              Privacy Policy
                            </h1>
                            {/* Two Column Layout */}
                            <div className="pdh-policy-layout">
                              {/* Main Content */}
                              <div className="pdh-policy-main">
                                {/* Intro Box */}
                                <div className="pdh-policy-intro-box">
                                  <p>
                                    We are committed to safeguarding the privacy
                                    and security of your personal information.
                                    This policy explains what personal data we
                                    collect, how we use it, the lawful bases for
                                    processing it, how you can exercise your
                                    rights, and what measures we take to protect
                                    it. We recommend that you read this policy
                                    in full. If you have any questions, please
                                    contact us at{" "}
                                    <a
                                      href="mailto:many@pawluna.art"
                                      className="pdh-policy-link"
                                    >
                                      many@pawluna.art
                                    </a>
                                    .
                                  </p>
                                </div>
                                {/* Section List */}
                                <div className="pdh-policy-sections">
                                  {/* 1. Who We Are */}
                                  <div className="pdh-policy-section">
                                    <ol start={1}>
                                      <li className="pdh-policy-section-title">
                                        Who We Are
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        1.1. Pawluna is responsible for the
                                        personal information we collect (the
                                        "controller" under data protection law).
                                        Our contact details can be found at the
                                        bottom of this policy.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 2. Information We Collect */}
                                  <div className="pdh-policy-section">
                                    <ol start={2}>
                                      <li className="pdh-policy-section-title">
                                        Information We Collect
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        2.1. We may collect, store, and use the
                                        following categories of personal
                                        information:
                                      </p>
                                      <div className="pdh-policy-bullet-list">
                                        <div className="pdh-policy-bullets">
                                          <span>·</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                        </div>
                                        <div className="pdh-policy-bullet-content">
                                          <p>
                                            Identity and Contact Data: Such as
                                            your name, billing and delivery
                                            address, email address, and
                                            telephone number.
                                          </p>
                                          <p>
                                            Financial Data: Payment details,
                                            including credit/debit card numbers,
                                            expiration dates, and security
                                            codes. (Note: These are processed
                                            securely by our payment service
                                            providers; we do not store full card
                                            details on our servers.)
                                          </p>
                                          <p>
                                            Transaction Data: Details about
                                            orders you have placed, returns, and
                                            refunds.
                                          </p>
                                          <p>
                                            Technical Data: Your IP address,
                                            browser type and version, time zone
                                            setting, operating system, and
                                            platform, as well as information
                                            about how you use our website.
                                          </p>
                                          <p>
                                            Marketing and Communications Data:
                                            Your preferences for receiving
                                            marketing information and
                                            communications from us.
                                          </p>
                                        </div>
                                      </div>
                                      <p className="pdh-policy-text">
                                        2.2. We collect personal information
                                        directly from you when you register for
                                        an account, place an order, sign up for
                                        newsletters, or interact with our
                                        website. Some data is collected
                                        automatically through cookies and
                                        similar technologies when you browse our
                                        site.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 3. Lawful Bases for Processing */}
                                  <div className="pdh-policy-section">
                                    <ol start={3}>
                                      <li className="pdh-policy-section-title">
                                        Lawful Bases for Processing
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        3.1. We will only collect and process
                                        your personal data where we have a
                                        lawful basis to do so. These lawful
                                        bases may include:
                                      </p>
                                      <div className="pdh-policy-bullet-list">
                                        <div className="pdh-policy-bullets">
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                        </div>
                                        <div className="pdh-policy-bullet-content">
                                          <p>
                                            Consent: When you have given clear
                                            consent for us to process your
                                            personal data for a specific purpose
                                            (e.g., receiving our newsletter).
                                          </p>
                                          <p>
                                            Contractual Necessity: When it is
                                            necessary for the performance of a
                                            contract with you (e.g., processing
                                            your order, delivering your
                                            products).
                                          </p>
                                          <p>
                                            Legitimate Interests: When the
                                            processing is necessary for our
                                            legitimate business interests,
                                            provided these are not overridden by
                                            your rights and interests (e.g.,
                                            improving our website user
                                            experience or understanding how
                                            customers use our services).
                                          </p>
                                          <p>
                                            Legal Obligation: When we must
                                            process your data to comply with a
                                            legal or regulatory obligation.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* 4. How We Use Your Information */}
                                  <div className="pdh-policy-section">
                                    <ol start={4}>
                                      <li className="pdh-policy-section-title">
                                        How We Use Your Information
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        4.1. We will use your personal data for
                                        one or more of the following purposes:
                                      </p>
                                      <div className="pdh-policy-bullet-list">
                                        <div className="pdh-policy-bullets">
                                          <span>·</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                        </div>
                                        <div className="pdh-policy-bullet-content">
                                          <p>
                                            To Process Your Orders: Including
                                            payment, shipping, and delivery.
                                          </p>
                                          <p>
                                            To Improve Our Website and User
                                            Experience: Ensuring our website
                                            content is user-friendly, secure,
                                            and up-to-date.
                                          </p>
                                          <p>
                                            To Provide Customer Support:
                                            Addressing your questions,
                                            complaints, and requests.
                                          </p>
                                          <p>
                                            To Send Marketing Communications: If
                                            you have opted in, we may send
                                            promotional offers, product news,
                                            and updates.
                                          </p>
                                          <p>
                                            To Comply with Legal Requirements:
                                            Such as fulfilling legal, tax, and
                                            regulatory obligations.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* 5. Marketing and Newsletter Communications */}
                                  <div className="pdh-policy-section">
                                    <ol start={5}>
                                      <li className="pdh-policy-section-title">
                                        Marketing and Newsletter Communications
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        5.1. If you choose to receive marketing
                                        communications, we may send you
                                        promotional offers, discounts, and
                                        company news. You can opt out at any
                                        time by:
                                      </p>
                                      <div className="pdh-policy-bullet-list">
                                        <div className="pdh-policy-bullets">
                                          <span>·</span>
                                          <span>·</span>
                                          <span>·</span>
                                        </div>
                                        <div className="pdh-policy-bullet-content">
                                          <p>
                                            Adjusting your preferences in the
                                            "My Account" section of our website.
                                          </p>
                                          <p>
                                            Clicking the "unsubscribe" link in
                                            any promotional email.
                                          </p>
                                          <p>
                                            Contacting us at{" "}
                                            <a
                                              href="mailto:many@pawluna.art"
                                              className="pdh-policy-link"
                                            >
                                              many@pawluna.art
                                            </a>{" "}
                                            and requesting removal.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* 6. Data Sharing and Disclosure */}
                                  <div className="pdh-policy-section">
                                    <ol start={6}>
                                      <li className="pdh-policy-section-title">
                                        Data Sharing and Disclosure
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        6.1. We value your privacy and will not
                                        share your personal information with
                                        third parties without your consent,
                                        except:
                                      </p>
                                      <div className="pdh-policy-bullet-list">
                                        <div className="pdh-policy-bullets">
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                        </div>
                                        <div className="pdh-policy-bullet-content">
                                          <p>
                                            Service Providers and Partners: We
                                            may share data with trusted vendors
                                            (e.g., payment processors, delivery
                                            companies) to fulfill orders,
                                            process payments, or provide other
                                            requested services.
                                          </p>
                                          <p>
                                            Legal Compliance: We may disclose
                                            information where required by law or
                                            where we believe disclosure is
                                            necessary to protect our rights,
                                            comply with judicial proceedings,
                                            court orders, or legal processes.
                                          </p>
                                          <p>
                                            Business Transfers: In the event of
                                            a merger, acquisition, or asset
                                            sale, your personal data may be
                                            transferred to the new owner.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* 7. Data Retention */}
                                  <div className="pdh-policy-section">
                                    <ol start={7}>
                                      <li className="pdh-policy-section-title">
                                        Data Retention
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        7.1. We will retain your personal data
                                        only for as long as necessary to fulfill
                                        the purposes we collected it for,
                                        including for the purposes of satisfying
                                        any legal, accounting, or reporting
                                        requirements. Specific retention periods
                                        are determined based on the nature of
                                        the data and the services provided. If
                                        you have any questions regarding our
                                        retention periods, please contact us at{" "}
                                        <a
                                          href="mailto:many@pawluna.art"
                                          className="pdh-policy-link"
                                        >
                                          many@pawluna.art
                                        </a>
                                        .
                                      </p>
                                    </div>
                                  </div>
                                  {/* 8. Your Rights Under Data Protection Law */}
                                  <div className="pdh-policy-section">
                                    <ol start={8}>
                                      <li className="pdh-policy-section-title">
                                        Your Rights Under Data Protection Law
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        8.1. Depending on where you live and
                                        subject to applicable law, you may have
                                        one or more of the following rights. We
                                        may need to verify your identity before
                                        completing a request:
                                      </p>
                                      <div className="pdh-policy-bullet-list">
                                        <div className="pdh-policy-bullets">
                                          <span>·</span>
                                          <span>·</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                        </div>
                                        <div className="pdh-policy-bullet-content">
                                          <p>
                                            Right to Access: You can request a
                                            copy of the personal data we hold
                                            about you.
                                          </p>
                                          <p>
                                            Right to Rectification: You can ask
                                            us to correct inaccurate or
                                            incomplete personal data.
                                          </p>
                                          <p>
                                            Right to Erasure ("Right to be
                                            Forgotten"): You can ask us to
                                            delete your personal data in certain
                                            circumstances.
                                          </p>
                                          <p>
                                            Right to Restrict Processing: You
                                            can request the restriction or
                                            suspension of the processing of your
                                            personal data under certain
                                            conditions.
                                          </p>
                                          <p>
                                            Right to Data Portability: You can
                                            request the transfer of your
                                            personal data to another
                                            organization or directly to you,
                                            where technically feasible.
                                          </p>
                                          <p>
                                            Right to Object: You can object to
                                            our processing of your personal data
                                            based on legitimate interests or for
                                            direct marketing.
                                          </p>
                                          <p>
                                            Right to Withdraw Consent: If we
                                            rely on your consent to process your
                                            personal data, you have the right to
                                            withdraw that consent at any time.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* 9. Complaints */}
                                  <div className="pdh-policy-section">
                                    <ol start={9}>
                                      <li className="pdh-policy-section-title">
                                        Complaints
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        9.1. If you are unhappy with how we
                                        handle your personal data, please
                                        contact us at many@pawluna.art so we can
                                        address your concerns. You may also
                                        contact the privacy or consumer
                                        protection authority available in your
                                        jurisdiction.
                                      </p>
                                      <p className="pdh-policy-text">
                                        9.2.{" "}
                                        <strong>
                                          Payment Information Security
                                        </strong>
                                        <br />
                                        Payment information is handled through
                                        the payment services made available at
                                        checkout. We do not intentionally store
                                        full payment-card numbers in our site
                                        records.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 10. Cookies and Analytics */}
                                  <div className="pdh-policy-section">
                                    <ol start={10}>
                                      <li className="pdh-policy-section-title">
                                        Cookies and Analytics
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        10.1. We use local storage to remember
                                        the contents of your shopping cart. We
                                        do not currently set our own analytics
                                        or advertising cookies. Please read our
                                        separate Cookie Policy for current
                                        categories, third-party resources, and
                                        browser controls.
                                      </p>
                                      <div className="pdh-policy-bullet-list">
                                        <div className="pdh-policy-bullets">
                                          <span>·</span>
                                          <span>&nbsp;</span>
                                        </div>
                                        <div className="pdh-policy-bullet-content">
                                          <p>
                                            How to Manage Cookies: You can set
                                            your browser to refuse cookies or
                                            alert you when cookies are being
                                            used. Please note that disabling
                                            cookies may affect the functionality
                                            of some parts of our website.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* 11. Third-Party Links */}
                                  <div className="pdh-policy-section">
                                    <ol start={11}>
                                      <li className="pdh-policy-section-title">
                                        Third-Party Links
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        11.1. Our website may contain links to
                                        external websites or services that we do
                                        not control. We are not responsible for
                                        the privacy practices of these
                                        third-party sites. We encourage you to
                                        review their privacy policies before
                                        submitting any personal information.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 12. Security Measures */}
                                  <div className="pdh-policy-section">
                                    <ol start={12}>
                                      <li className="pdh-policy-section-title">
                                        Security Measures
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        12.1. We implement appropriate technical
                                        and organizational measures to protect
                                        your personal data against unauthorized
                                        access, loss, or damage. Although we
                                        strive to protect your personal data, no
                                        security measures are entirely
                                        foolproof. If you suspect any misuse of
                                        your personal data, please contact us
                                        immediately.
                                      </p>
                                    </div>
                                  </div>
                                  {/* 13. Changes to This Policy */}
                                  <div className="pdh-policy-section">
                                    <ol start={13}>
                                      <li className="pdh-policy-section-title">
                                        Changes to This Policy
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        13.1. We may update this Privacy Policy
                                        from time to time. When we
                                        do so, we will revise the "last updated"
                                        date below. Your continued use of our
                                        website after any changes indicates your
                                        acceptance of these changes. Please
                                        check this policy regularly for updates.
                                      </p>
                                      <p className="pdh-policy-text">
                                        13.2. Privacy rights vary by location.
                                        We apply applicable United States
                                        federal and state privacy requirements
                                        and honor additional rights where they
                                        legally apply to a visitor.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                {/* Footer Divider and Last Updated */}
                                <div className="pdh-policy-footer">
                                  <div className="pdh-policy-footer-divider" />
                                  <p className="pdh-policy-last-updated">
                                    Last updated: October 16, 2026
                                  </p>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Privacy;
